export default '/build/f7ddb663.svg'